var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactNative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8925 18.667C6.3 20.5558 2 23.7919 2 27.4862C2 33.3388 13.0125 38.1109 26.625 38.1109C28.475 38.1109 29.775 38.0026 31.5 37.8415",
    stroke: "#00FFE0",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5925 37.833C20.56 36.1775 19.5775 34.6859 18.6425 32.8332C11.765 19.2224 9.92254 5.69497 14.5675 2.63116C17.4425 0.695095 22.185 3.33392 27.0025 8.89211",
    stroke: "#00FFE0",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0726 36.4081C11.3176 43.8746 11.6726 49.5078 14.4726 51.3938C18.9301 54.3937 27.9401 45.9551 34.5801 32.4943C35.4801 30.6332 36.2876 28.8027 37.0001 27",
    stroke: "#00FFE0",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45.1109C31.82 50.6664 36.5425 53.3052 39.445 51.3691C44.07 48.3081 42.2475 34.7807 35.3625 21.1671C34.4025 19.2866 33.42 17.8227 32.4125 16.1672",
    stroke: "#00FFE0",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.15 35.3331C47.68 33.4248 52 30.1944 52 26.5111C52 20.6502 40.98 15.8892 27.3875 15.8892C25.52 15.8892 24.2225 15.9697 22.5 16.1308",
    stroke: "#00FFE0",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27.0004C17.7125 25.1671 18.5175 23.3672 19.42 21.5061C26.0375 8.05089 35.0525 -0.410011 39.535 2.61491C42.31 4.50098 42.69 10.1314 40.935 17.5951M27.65 27.0421H27.625C27.6 27.4032 27.325 27.7087 26.975 27.7087C26.8076 27.6995 26.6497 27.6196 26.5335 27.4854C26.4174 27.3512 26.3517 27.1727 26.35 26.9865C26.35 26.5976 26.625 26.2921 26.95 26.2921H26.925C27.25 26.2643 27.55 26.5976 27.55 26.9587",
    stroke: "#00FFE0",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNative);
export default __webpack_public_path__ + "static/media/React-Native.6e06842338aa324a9ec9d20a7644b6ea.svg";
export { ForwardRef as ReactComponent };